import { render, staticRenderFns } from "./ClassCES7Star.vue?vue&type=template&id=3b0a9d76&"
import script from "./ClassCES7Star.vue?vue&type=script&lang=ts&"
export * from "./ClassCES7Star.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports